/**
 * Product Zoom Modal - Theme _lime
 * @description Sistema de zoom modal para imagens de produtos (tema _lime)
 * @version 1.0.0
 * @author Irroba Platform
 * 
 * Funcionalidades:
 * - Abrir modal de zoom com imagem ampliada
 * - Navegação entre imagens (anterior/próximo)
 * - Aplicação de zoom elevateZoom/ezPlus
 * - Suporte a múltiplas imagens do produto
 * 
 * Seletores utilizados:
 * - .productMainCarousel - Carousel principal de imagens (_lime theme)
 * - .swiper-slide - Slides do carousel
 * - .swiper-slide-active - Slide ativo
 */

/**
 * Adiciona imagem ao dialog de zoom
 * @param {jQuery} image - Elemento de imagem a ser clonado
 */
function addImageDialogZoom(image) {
    let $clonedImg = $(image).clone();
    
    // Usa data-original-zoom se disponível, senão usa o src
    let zoomImageSrc = $(image).attr('data-original-zoom') || $(image).attr('src');
    
    $clonedImg
        .attr('src', zoomImageSrc)
        .addClass('ez-plus')
        .appendTo('.dialog-box-image-zoom.active .dialog-box.dialog');
    
    let $imageZoom = $(".dialog-box-image-zoom .dialog-box.dialog img.ez-plus");
    applyZoom($imageZoom);
}

/**
 * Abre o dialog de zoom
 */
function openDialogZoom() {
    $('.dialog-box-image-zoom').addClass('active');
    
    // Calcula largura da scrollbar e ajusta body
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    $('body').css({
        overflow: 'hidden',
        'padding-right': `${scrollbarWidth}px`
    });

    // Remove imagens duplicadas antes de adicionar nova
    $('.dialog-box-image-zoom .dialog-box.dialog img').remove();

    // Adiciona imagem ativa do carousel principal (_lime theme)
    addImageDialogZoom($('.productMainCarousel .swiper-slide-active img'));
}

/**
 * Fecha o dialog de zoom
 */
function closeDialogZoom() {
    $('.dialog-box-image-zoom').removeClass('active');
    
    // Restaura body e header
    $('body, header').css({
        overflow: '',
        'padding-right': ''
    });
    
    // Remove container de zoom
    $('.zoomContainer').remove();
    
    // Remove imagens do dialog após animação
    setTimeout(function() {
        $('.dialog-box-image-zoom .dialog-box.dialog img').remove();
    }, 200);
}

/**
 * Navega entre as imagens no modal de zoom
 * @param {string} direction - Direção da navegação ('prev' ou 'next')
 */
function changeModalZoomItem(direction) {
    const $slides = $('.productMainCarousel .swiper-slide');
    const total = $slides.length;

    // Obtém índice atual da imagem no dialog
    let currentIndex = $('.dialog-box-image-zoom .dialog-box.dialog img').data('target-item') || 0;

    // Remove imagem atual
    $('.dialog-box-image-zoom .dialog-box.dialog img').remove();

    /**
     * Encontra próximo índice válido (que não seja vídeo/iframe)
     * @param {number} startIndex - Índice inicial
     * @param {number} step - Direção do passo (-1 ou 1)
     * @returns {number} - Índice válido encontrado
     */
    const findNextValidIndex = (startIndex, step) => {
        let index = startIndex;
        for (let i = 0; i < total; i++) {
            index = (index + step + total) % total;
            const $slide = $slides.eq(index);
            // Valida se slide contém imagem e não é vídeo
            if ($slide.find('iframe').length === 0 && $slide.find('img').length > 0) {
                return index;
            }
        }
        return startIndex;
    };

    // Determina novo índice baseado na direção
    if (direction === 'prev') {
        currentIndex = findNextValidIndex(currentIndex, -1);
    } else if (direction === 'next') {
        currentIndex = findNextValidIndex(currentIndex, 1);
    }

    // Adiciona nova imagem
    const $newImg = $slides.eq(currentIndex).find('img');
    addImageDialogZoom($newImg);

    // Atualiza índice armazenado
    $('.dialog-box-image-zoom .dialog-box.dialog img').data('target-item', currentIndex);
}

/**
 * Aplica zoom na imagem usando ezPlus/elevateZoom
 * @param {jQuery} el - Elemento de imagem
 */
function applyZoom(el) {
    // Remove containers anteriores de zoom
    $('.zoomContainer').remove();

    // Verifica se plugin está disponível
    if (typeof $.fn.elevateZoom !== 'function' && typeof $.fn.ezPlus !== 'function') {
        console.warn('Plugin de zoom não encontrado (elevateZoom ou ezPlus)');
        return;
    }

    // Obtém tipo de zoom da configuração (se disponível)
    const zoomType = window.productZoomType || 'inner';

    // Configurações de zoom baseadas no tipo
    const zoomConfigs = {
        inner: {
            backgroundImage: el.attr('data-original-zoom') || el.attr('data-zoom') || el.attr('src'),
            zoomType: 'inner',
            cursor: 'crosshair',
            lensShape: 'round',
        },
        lens: {
            zoomType: 'lens',
            lensShape: 'round',
            lensSize: 250
        },
        square: {
            constrainType: 'height',
            constrainSize: 274,
            zoomType: 'lens'
        },
        ex_square: {
            zoomWindowPosition: 1,
            easing: true,
            zoomWindowWidth: 300,
            zoomWindowHeight: 300
        }
    };

    // Aplica configuração de zoom
    const config = zoomConfigs[zoomType] || zoomConfigs.inner;
    
    if (typeof $.fn.ezPlus === 'function') {
        el.ezPlus(config);
    } else if (typeof $.fn.elevateZoom === 'function') {
        el.elevateZoom(config);
    }
}

/**
 * Inicializa eventos do zoom modal
 */
function initProductZoomModal() {
    // Fecha modal ao clicar no backdrop
    $(document).on('click', '.dialog-box-image-zoom.backdrop', function(e) {
        if ($(e.target).closest('.dialog, .content-buttons').length) {
            return;
        }
        closeDialogZoom();
    });

    // Fecha modal ao clicar no botão de fechar
    $(document).on('click', '.handle-close-dialog-zoom', function() {
        closeDialogZoom();
    });

    // Navega para imagem anterior
    $(document).on('click', '.button-prev-modal-zoom', function() {
        changeModalZoomItem('prev');
    });

    // Navega para próxima imagem
    $(document).on('click', '.button-next-modal-zoom', function() {
        changeModalZoomItem('next');
    });

    // Abre modal ao clicar no botão de zoom
    $(document).on('click', '.handle-open-modal-zoom', function() {
        openDialogZoom();
    });

    // Fecha modal com tecla ESC
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('.dialog-box-image-zoom').hasClass('active')) {
            closeDialogZoom();
        }
    });
}

// Auto-inicializa quando documento estiver pronto
$(document).ready(function() {
    initProductZoomModal();
});

// Exporta funções para uso global
if (typeof window !== 'undefined') {
    window.openDialogZoom = openDialogZoom;
    window.closeDialogZoom = closeDialogZoom;
    window.changeModalZoomItem = changeModalZoomItem;
    window.applyZoom = applyZoom;
    window.addImageDialogZoom = addImageDialogZoom;
}
